import { render, staticRenderFns } from "./Masthead.vue?vue&type=template&id=81d1a632&scoped=true"
import script from "./Masthead.vue?vue&type=script&setup=true&lang=js"
export * from "./Masthead.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Masthead.vue?vue&type=style&index=0&id=81d1a632&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d1a632",
  null
  
)

export default component.exports